import { createStore, applyMiddleware, type PreloadedState } from 'redux';
import { createEpicMiddleware, type Epic } from 'redux-observable';
import composeWithDevtools from '@atlassian/jira-common-util-compose-with-devtools/src/index.tsx';
import type { Action } from './actions.tsx';
import rootReducer from './reducer.tsx';
import type { State } from './types.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	rootEpic: Epic<Action, State>,
	initialState: PreloadedState<State>,
	middlewares = [],
) =>
	createStore(
		rootReducer,
		initialState,
		composeWithDevtools({ name: 'Create component modal' })(
			applyMiddleware(...middlewares, createEpicMiddleware(rootEpic)),
		),
	);
